export function setHeight() {
    let arrHeights = [];
    $(".plans-cards").each(function () {
        const holder = $(this);
        const card = holder.find(".card");

        card.find('.cell').each(function (index) {
            arrHeights = [];
            let cell = holder.find(".card").find(`.cell:eq(${index})`);
            cell.css("min-height", "auto");
            card.each(function () {
                $(this).find(".cell").eq(index).outerHeight(true) > 0 ?
                    arrHeights.push($(this).find(".cell").eq(index).outerHeight(true)) :
                    arrHeights.push(0);
            });
            cell.css("min-height", Math.max.apply(Math, arrHeights));
        });
    });
}

export function plans() {
    $(window).on("load resize", function () {
        setHeight();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/plans.js